export default __webpack_public_path__ + "c9543f5306e210e846296ba928ee9b57.png";